(function (window, document) {
    'use strict';

    function getRoot() {
        const sectionId = getSectionId();
        const selector = sectionId
            ? '[data-offer-progress-root][data-section-id="' + sectionId + '"]'
            : '[data-offer-progress-root]';

        return document.querySelector(selector);
    }

    function getSectionId() {
        const root = document.querySelector('[data-offer-progress-root]');
        return root ? root.getAttribute('data-section-id') : '';
    }

    function waitForCore(callback) {
        if (window.FreeBouquetsCore) {
            callback();
            return;
        }

        window.addEventListener('FreeBouquetsCore:ready', function onReady() {
            window.removeEventListener('FreeBouquetsCore:ready', onReady);
            callback();
        });
    }

    function init() {
        const FBC = window.FreeBouquetsCore;
        const data = window.FreeBouquets || {};
        const root = getRoot();

        if (!root) return;

        if (!data.customer) {
            root.style.display = 'none';
            return;
        }

        const getAll = function (selector) {
            return Array.from(root.querySelectorAll(selector));
        };

        const setDisplay = function (selector, value) {
            getAll(selector).forEach(function (item) {
                item.style.display = value;
            });
        };

        const addClass = function (selector, className) {
            getAll(selector).forEach(function (item) {
                item.classList.add(className);
            });
        };

        const removeClass = function (selector, className) {
            getAll(selector).forEach(function (item) {
                item.classList.remove(className);
            });
        };

        const setText = function (selector, text) {
            getAll(selector).forEach(function (item) {
                item.innerText = text;
            });
        };

        const setHtml = function (selector, html) {
            getAll(selector).forEach(function (item) {
                item.innerHTML = html;
            });
        };

        const hideFreeBouquetBanner = function () {
            setDisplay('.ig-free-bouquet-banner', 'none');
        };

        const showFreeBouquetBanner = function () {
            setDisplay('.ig-free-bouquet-banner', '');
        };

        hideFreeBouquetBanner();

        setHtml(
            '.ig-offer-progress__info',
            'Sign in to track your <br/> or start your first order now'
        );

        setDisplay('.ig-offer-progress__info-text', 'none');
        removeClass('.ig-offer-progress__btn--ghost', 'hidden');

        const reward = FBC.getRewardState(data.orders || []);

        if (reward.isLocked) {
            setText('.ig-offer-progress__info', '0 of 2 orders completed');
            return;
        }

        if (reward.isAlmost) {
            addClass('.ig-offer-progress__point--1', 'is-active');
            removeClass('.ig-offer-progress__days', 'hidden');

            setText('.ig-offer-progress__info', '1 of 2 orders completed');
            setDisplay('#limited-offer', 'none');

            setHtml(
                '[data-offer-days]',
                'Left: <span class="ig-offer-progress__days-value">' + reward.daysLeft + ' day</span>'
            );

            root.classList.add('has-1-active-order');
            return;
        }

        if (reward.isUnlocked) {
            addClass('.ig-offer-progress__point--1', 'is-active');
            addClass('.ig-offer-progress__point--2', 'is-active');
            addClass('.ig-offer-progress__point--3', 'is-active');

            root.classList.add('has-free-bouquet');

            setText('.ig-offer-progress__info', '2 of 2 orders completed');
            setDisplay('#limited-offer', 'none');

            showFreeBouquetBanner();

            if (reward.promoEndDateFormatted) {
                setText(
                    '.ig-free-bouquet-banner__subtitle',
                    'Pick it up before ' + reward.promoEndDateFormatted
                );
            }
        }
    }

    function start() {
        waitForCore(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }

    document.addEventListener('shopify:section:load', function (event) {
        const sectionId = getSectionId();
        if (!sectionId) {
            start();
            return;
        }

        if (event && event.detail && event.detail.sectionId === sectionId) {
            start();
        }
    });
})(window, document);